"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upsellSelectors = require("../../store/upsell/upsellSelectors");
var _upsellActions = require("../../store/upsell/upsellActions");
var _constants = require("../../utils/constants");
var _useDynamicPageContent = _interopRequireDefault(require("../../hooks/dynamic/useDynamicPageContent"));
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useUpsellAccessoryState = () => {
  const selectedUpsellProducts = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectSelectedUpsellProducts);
  const displayedUpsellProductDetails = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectDisplayedUpsellProductDetails);
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    setDynamicContentPage
  } = (0, _useDynamicPageContent.default)();
  const goToUpsellDetailsPage = () => {
    setDynamicContentPage(_constants.DYNAMIC_PAGES.UPSELL_DETAILS);
  };
  const addDisplayedUpsellProductDetailsCallback = product => {
    dispatch((0, _upsellActions.addDisplayedUpsellProductDetails)(product));
  };
  const removeDisplayedUpsellProductDetailsCallback = () => {
    var _selectedUpsellProduc;
    if (!(selectedUpsellProducts !== null && selectedUpsellProducts !== void 0 && (_selectedUpsellProduc = selectedUpsellProducts.accessory) !== null && _selectedUpsellProduc !== void 0 && _selectedUpsellProduc.length)) dispatch((0, _upsellActions.setIsConnectivityPlanSelected)(false));
    dispatch((0, _upsellActions.removeDisplayedUpsellProductDetails)(displayedUpsellProductDetails === null || displayedUpsellProductDetails === void 0 ? void 0 : displayedUpsellProductDetails.product));
  };
  return {
    goToUpsellDetailsPage,
    addDisplayedUpsellProductDetails: addDisplayedUpsellProductDetailsCallback,
    removeDisplayedUpsellProductDetails: removeDisplayedUpsellProductDetailsCallback
  };
};
var _default = useUpsellAccessoryState;
exports.default = _default;